import React from 'react';
import autobind from 'autobind-decorator';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import config from 'client/shared/config';
import DeleteButton from 'common/components/delete-button';

import ApprovalMatrix from './approval-matrix'

@inject('artistStore')
class AuditionHeader extends React.Component {
	render () {
		const {
			artistStore,
			artistStore: {
				data: {
					artist
				}
			}
		 } = this.props;

		const style = {
			backgroundImage: `url("${artistStore.getArtistImage()}")`
		};

		const deleteConfMsg = `Really delete submission from ${artistStore.get('artist.name')}?`;
		console.log("AAA: " + artist.get('_id'))

		return (
			<div className="cell small-8">
				<div className="grid-x grid-padding-x grid-padding-y align-middle">
					<div className="cell small-2">
						<div style={ style } className="image small"></div>
					</div>

					<div className="cell auto">
						<div className="grid-x">
							<div className="cell small-12">
								<h2
									data-ta="auditionHeader"
									className="margin-0"
								>
									{ artist.get('name') }
								</h2>
							</div>

							<div className="cell shrink">
								<NavLink
									className="button clear padding-left-0"
									to={ `/artist/info/${artist.get('_id')}` }
								>
									<span className="fas fa-pencil"></span> Edit Artist Info
								</NavLink>
							</div>

							<div className="cell shrink">
								<DeleteButton
									warningText={ deleteConfMsg }
									onConfirmClick={ this.onConfirmClick }
								>
									<button className="button clear alert">
										<span className="fas fa-trash"></span> Delete Submission
									</button>
								</DeleteButton>
							</div>
						</div>
					</div>
				</div>

				<div className="grid-x grid-padding-x grid-padding-y">
					<div className="cell">
						<ApprovalMatrix />
					</div>
				</div>
			</div>
		);
	}

	@autobind
	async onConfirmClick () {
		const { artistStore } = this.props;
		try {

			await artistStore.deleteItem(artistStore.data.artist.toPOJO());
			window.location.href = config.paths.admin.submissionsHomePath;
		} catch (err) {

			console.error('[ERROR DELETING ARTIST]', err);
		}
	}
}

export default AuditionHeader;
